<template>
    <section class="section_2">
        <div class="selling_top_section">
            <div class="container">
                <h2>{{ cmsData.selling_title }}</h2>
                <p>{{ cmsData.selling_sub_title }}</p>
            </div>
        </div>
        <div class="container">
            <div class="menu-category menu-category-hide">
                <div class="menu-category-content">
                    <div class="menu-category-elements">
                        <ul class="variable variable-header slider">
                            <carousel   :smartSpeed="1000" :autoplayHoverPause="true" :playSpeed="5000" :centerMode="true" :paginationEnabled="true"   :perPageCustom="[[320,4],[800, startSelling.length]]" :autoplay="true" :loop="true" :navigate-to="someLocalProperty" :mouse-drag="false">
                                <slide v-for="row in startSelling" :key="row.id" :title="row.device_name">
                                <!-- <li> -->
                                    <div class="menu-category-element">
                                        <router-link to="/sell-device" class="menu-category-element-content">
                                            <div class="menu-category-element-head menu-category-element-head-m1">
                                                <div class="menu-category-element-head-big">
                                                    <img :src="imagePath + row.icon" :alt="row.icon" />
                                                </div>
                                            </div>
                                            <div class="menu-category-element-footer">
                                                <div class="menu-category-element-footer-content">
                                                    {{row.device_name}}
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                <!-- </li> -->
                                </slide>
                            </carousel>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: "SellingHome",
    props:['cmsData','startSelling'],
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            customerExperiencesData: [],
            imagePath: this.$api + "upload/home_start_sell/"
        };
    }
}
</script>